import type { PageTemplateProps } from "./pageTemplateTypes";

/**
 * React translation of the old {@code salesCampaignPage.jsp}:
 *
 * - a {@code ContentStreamSlot} CMS slot, wrapped in the legacy {@code span-24}
 *   layout div, rendered FIRST;
 * - the route body (the former {@code root_salesCampaign} island mount) AFTER.
 *
 * Structure-copy parity: slot order (ContentStreamSlot before body) and the
 * {@code span-24} wrapper class are preserved from the JSP.
 */
export function SalesCampaignPageTemplate({ slots, body }: PageTemplateProps) {
  return (
    <>
      <div>
        <div className="span-24">{slots.renderSlot("ContentStreamSlot")}</div>
      </div>
      {body}
    </>
  );
}
